<template>
  <div class="title" :class="'title--' + size">
    <!-- eslint-disable vue/no-v-html -->
    <h1 v-if="h1" class="title__text" v-html="text" />
    <div v-else class="title__text" v-html="text" />
    <!-- eslint-enable vue/no-v-html -->
  </div>
</template>

<script>
export default {
  props: {
    h1: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/helpers/variables";
@import "../../assets/styles/helpers/mixin";
.title {
  position: relative;
  margin-bottom: 1.4rem;
  color: $text_gray;

  &--small {
    .title__text {
      font-size: 2rem;
    }
  }

  &__text {
    font-size: 4.4rem;
    line-height: 5.2rem;
    font-weight: 700;
    @include below($lg) {
      font-size: 2.4rem;
      line-height: 2.8rem;
    }
  }
}
</style>
